import React from "react";

const SkeletonTable = ({rows=6,col=8}) => {
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead>
          <tr>
            {[...Array(col)].map((_, idx) => (
              <th key={idx} className="px-4 py-2">
                <div className="h-4 bg-gray-300 rounded w-3/4 animate-pulse" />
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          {[...Array(rows)].map((_, rowIdx) => (
            <tr key={rowIdx}>
              {[...Array(col)].map((_, colIdx) => (
                <td key={colIdx} className="px-4 py-4">
                  <div className="h-4 bg-gray-200 rounded animate-pulse" />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SkeletonTable;
